var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.919 6a3 3 0 100-6 3 3 0 000 6zm-2 1a4 4 0 00-4 4v1a1 1 0 001 1h10a1 1 0 001-1v-1a4 4 0 00-4-4h-4z",
    fill: "#F5F8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.419 5.599a3 3 0 100-5.197 2.999 2.999 0 010 5.197zm3.5 7.401h3a1 1 0 001-1v-1a4 4 0 00-4-4h-3a4 4 0 014 4v1a1 1 0 01-1 1z",
    fill: "#F5F8FF"
  })));
}
export default __webpack_public_path__ + "static/org_icon.0cc9d8c5.svg";
export { SvgOrgIcon as ReactComponent };